import type {
    ViolationDetailTaskCheckPayload,
    ViolationDetailTaskCheckResponse,
} from '@/types/apps/violation-detail-task-check.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

export interface ViolationDetailTaskCheckServiceInterface {}

type ViolationTypeListResponse = ApiResponse<
    PaginatedResult<ViolationDetailTaskCheckResponse>
>;

export class ViolationDetailTaskCheckService
    implements Showable, Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        base: () => '/api/violation-detail-task-checks',
        detail: (id: string) => `/api/violation-detail-task-checks/${id}`,
    };

    public index(params?: QueryParams): Promise<ViolationTypeListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<ViolationDetailTaskCheckResponse>> {
        const url = this.endpoints.detail(id);

        return this.apiClient.fetchApi(url, params);
    }

    public create(
        payload: ViolationDetailTaskCheckPayload
    ): Promise<ApiResponse<ViolationDetailTaskCheckResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: ViolationDetailTaskCheckPayload
    ): Promise<ApiResponse<ViolationDetailTaskCheckResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }
    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        const url = this.endpoints.base();

        return this.apiClient.destroyApi<void>(url, ids, isHardDeleted);
    }
}
